// src/PlaceBid.js
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';

const PlaceBid = () => {
  const { auctionCode, itemId } = useParams();  // Get auctionCode and itemId from the URL
  const [bidAmount, setBidAmount] = useState('');

  const handlePlaceBid = async () => {
    if (!bidAmount) {
      alert('Please enter a bid amount.');
      return;
    }

    const { data, error } = await supabase
      .from('bids')
      .insert([
        {
          auction_code: auctionCode,
          item_name: itemId,  // Assuming item name is passed as itemId in URL
          bid_amount: bidAmount,
          bidder_email: 'user-email@example.com'  // You should replace this with the actual user's email
        }
      ]);

    if (error) {
      console.error('Error placing bid:', error);
    } else {
      alert('Bid placed successfully!');
    }
  };

  return (
    <div>
      <h1>Place a Bid</h1>
      <input
        type="number"
        placeholder="Enter your bid amount"
        value={bidAmount}
        onChange={(e) => setBidAmount(e.target.value)}
      />
      <button onClick={handlePlaceBid}>Place Bid</button>
    </div>
  );
};

export default PlaceBid;
